import EfVideo from '@elem/ui/ef-video';
import css from './index.module.scss';
import EfSpec from '@elem/ui/ef-spec';
import { useLang } from '@/i18n';
import { useEffect, useRef, useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';
const IconRePlay = (props: any) => {
    return (
        <div {...props}>
            <img
                src="https://websiteoss.ecoflow.com/upload/image/1773215072797/Frame%20128720591.png"
                alt="replay"
            />
        </div>
    );
};
interface ItemProps {
    sources?: [string, string];
    posters?: [string, string];
    img?: [string, string];
    tab: string;
    desc: string;
    btn?: string;
    btnLink?: string;
    icon: string;
}
export default function OASIS2Us() {
    const { t } = useLang('delta_pro_ultra.launch.detail.OASIS');
    const [enter, setEnter] = useState(false);
    const [active, setActive] = useState(0);
    const tabsRef = useRef<HTMLUListElement>(null);
    const lineRef = useRef<HTMLParagraphElement>(null);

    const items: ItemProps[] = [
        {
            sources: [
                'https://websiteoss.ecoflow.com/upload/video/1773217972088/%E5%9C%B0%E9%9D%A2%E5%A4%AA%E9%98%B3%E8%83%BD.mp4',
                'https://websiteoss.ecoflow.com/upload/video/1773217924149/%E5%9C%B0%E9%9D%A2%E5%A4%AA%E9%98%B3%E8%83%BD.mp4',
            ],
            posters: [
                'https://websiteoss.ecoflow.com/upload/image/1773199152311/5-pc-1.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1773199151157/5-m-1.jpg',
            ],
            tab: t('OASIS2_item1_tab'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1772621006531/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%204%20(1).png',
            desc: t('OASIS2_item1_desc'),
            btn: t('OASIS2_item1_btn'),
            btnLink: "https://www.ecoflow.com/us/blog/saving-money-with-shp2"
        },
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1773199152164/5-pc-2.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1773199151290/5-m-2.jpg',
            ],
            tab: t('OASIS2_item2_tab'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1772621006722/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%205.png',
            desc: t('OASIS2_item2_desc'),

        },
        {

            img: [
                'https://websiteoss.ecoflow.com/upload/image/1773199151890/5-pc-3.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1773199151497/5-m-3.jpg',
            ],
            tab: t('OASIS2_item3_tab'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1772621047622/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%206.png',
            desc: t('OASIS2_item3_desc'),

        },
        {
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1773199152732/5-pc-4.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1773199152638/5-m-4.jpg',
            ],
            tab: t('OASIS2_item4_tab'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1772621047622/%E7%BC%96%E7%BB%84%205%E5%A4%87%E4%BB%BD%206.png',
            desc: t('OASIS2_item4_desc'),
            btn: t('OASIS2_item4_btn'),
            btnLink: "https://us.ecoflow.com/products/powerpulse-ev-charger"

        },
    ];

    const positionLine = (tabEl: HTMLElement) => {
        const line = lineRef.current;
        if (!line) return;
        const { left, width } = tabEl.getBoundingClientRect();
        const { left: parentLeft = left } = tabEl.parentElement?.getBoundingClientRect() ?? {};
        const scrollX = (tabEl.parentElement as HTMLElement).scrollLeft ?? 0;
        line.style.transform = `translateX(${left - parentLeft + scrollX}px)`;
        line.style.width = `${width}px`;
    };

    const handleChangeTab = (e: React.MouseEvent<HTMLLIElement>, k: number) => {
        const target = e.currentTarget as HTMLElement;
        positionLine(target);

        if (window.innerWidth <= 1024) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        setActive(k);

        const targetVideo = document.querySelector(`.OASIS-2-us .video${k + 1} video`) as HTMLVideoElement;
        if (targetVideo) {
            targetVideo.currentTime = 0;
            targetVideo.play();
        }
    };

    useEffect(() => {
        const firstTab = tabsRef.current?.querySelector('.tab') as HTMLElement;
        if (firstTab) positionLine(firstTab);
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const scene = AniContainer.create({
                triggerElement: '.OASIS-1',
                triggerHook: 1,
                offset: '100%',
                onEnter: () => setEnter(true),
            });

            return () => {
                scene.destroy();
            };
        }
    }, []);

    return (
        <>
            <section id="OASIS-2-us" className={`OASIS-2-us ${css['OASIS-2-us']}`}>
                <EfSpec />
                <div className="info">
                    <h2 className="title">{t('OASIS2_title')}</h2>
                    <p className="subtitle">{t('OASIS2_subtitle')}</p>
                </div>
                <ul className="videos">
                    {items?.map((item: ItemProps, k: number) => (
                        <li key={k} className={`video video${k + 1} ${k === active ? 'active' : ''}`}>
                            {item.img ? (
                                <EcoImg className="tab-img" pc={item.img[0]} h5={item.img[1]} />
                            ) : (
                                enter && (
                                    <EfVideo
                                        className="video-inner"
                                        pc={item.sources![0]}
                                        h5={item.sources![0]}
                                        poster={item.posters![0]}
                                        posterH5={item.posters![1]}
                                        loop={true}
                                        // Icon={IconRePlay}
                                        autoPlay={true}
                                    />
                                )
                            )}
                        </li>
                    ))}
                </ul>
                <ul className="tabs" ref={tabsRef}>
                    {items?.map((item: ItemProps, k: number) => (
                        <li
                            key={k}
                            className={`tab ${active === k ? 'active' : ''}`}
                            onClick={(e: React.MouseEvent<HTMLLIElement>) => handleChangeTab(e, k)}
                        >
                            <span className="tab-text">{item.tab}</span>
                        </li>
                    ))}
                    <p className="line" ref={lineRef}></p>
                </ul>
                <div className="bottom">
                    <p className="desc">{items[active].desc}</p>
                    {items[active].btn && <a className="btn" href={items[active].btnLink}>{items[active].btn}</a>}
                </div>
            </section>
        </>
    );
}
